import React from 'react';
import cx from 'classnames';
import _ from 'lodash';

import {PlayIcon} from '../../components/svg';

const VideoThumbnail = ({imageUrl, alt = '', className}) => (
  <div className={cx('relative flex justify-center items-center rounded-none bg-indigo-100', className)}>
    <PlayIcon className="absolute h-6 w-6 transition-all group-hover:h-7 group-hover:w-7" />
    {imageUrl && <img src={imageUrl} alt={alt} className="w-full h-full object-cover" />}
  </div>
);

export default VideoThumbnail;
